import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { match as urlMatch } from 'react-router'

import Content from '../../shared/content'
import Page from '../../shared/page_wrapper'

import Box from 'components/Box'
import Heading from 'components/Heading'
import { Loader } from 'components/Preloader'
import Section from 'components/Section'
import { Size } from 'components/Section/Section'
import MultiLinkSwitch from '../../../elements/buttons/MultiLinkSwitch'
import NumberPeople from '../../../elements/buttons/NumberPeople'
import TransportLinkSwitch, {
  IconType,
} from '../../../elements/buttons/transport/TransportLinkSwitch'
import Calendar from '../../../elements/Calendar'
import FunnelFooter from '../../../elements/footers/funnelFooter'
import FunnelBreadcrumbs from '../../../elements/FunnelBreadcrumbs'
import GiftcardModal from '../../../elements/modals/GiftcardModal'
import PersonModal from '../../../elements/modals/PersonModal'
import PriceErrorModal from '../../../elements/modals/PriceErrorModal'

import { EntryKey } from '../../../data/entries/types'
import { CountryAirports } from '../../../data/models/funnelOrder/airport'
import { Theme } from '../../../data/models/funnelOrder/theme'
import {
  getThemeColour,
  getThemeSectionProps,
} from '../../../data/models/funnelOrder/utils'
import { SiteCountry } from '../../../data/models/locale'
import { AppState } from '../../../data/state'
import { FunnelStep } from '../../../data/ui'
import { getNameWithTheme, Sredirect } from '../../../routing/links'
import { addToCart } from '../../../tracking/actions/addToCart'
import { MonthData } from './wrapperFunction'

export enum QueryKey {
  numberOfDays = 'days',
  region = 'destination',
  outboundDepartureTime = 'outgoingTime',
  inboundDepartureTime = 'incomingTime',
  roomType = 'roomType',
  airports = 'airports',
  destinationDriveType = 'driveDestination',
  month = 'month',
  year = 'year',
}

interface WrapperProps extends WrapperOwnProps {
  airports: CountryAirports[]
  country: SiteCountry
  theme: Theme
  nextStepDisabled: boolean
  prices: MonthData[]
  loading: boolean
  children?: React.ReactNode | undefined
}

interface WrapperOwnProps {
  page: string
  match: urlMatch<any>
}

interface WrapperState {
  redirect: string | null
  redirectParams?: any
}

class Wrapper extends React.Component<WrapperProps, WrapperState> {
  constructor(props: WrapperProps) {
    super(props)
    this.state = {
      redirect: null,
    }
  }

  public render() {
    if (this.state.redirect) {
      return (
        <Sredirect
          name={this.state.redirect}
          params={this.state.redirectParams}
          push
        />
      )
    }

    const { page, match, prices, loading, nextStepDisabled } = this.props

    const colour = getThemeColour(this.props.theme, EntryKey.none)
    const sectionProps = getThemeSectionProps(this.props.theme, EntryKey.none)

    return (
      <Page page={page} match={match} color={colour} navBarType="funnel">
        <Section {...sectionProps} size={Size.xs}>
          <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
          <Heading level={1}>
            <Content
              addNode
              contentKey={
                this.props.theme === Theme.drive ||
                this.props.theme === Theme.multiDrive
                  ? 'assemble-road'
                  : 'assemble'
              }
            >
              Assemble your trip
            </Content>
          </Heading>
          <div className={'clearfix'}>
            <div className="pull-left">
              <TransportLinkSwitch iconType={IconType.blue} />
            </div>
            <div className="pull-right padding-t-s-7">
              <NumberPeople />
            </div>
          </div>
          <PersonModal />
          {this.props.theme !== Theme.train ? (
            <MultiLinkSwitch
              onSetRedirect={redirect => this.setState({ redirect })}
            />
          ) : (
            <br />
          )}
          <div className="margin-b-m" style={{ position: 'relative' }}>
            <Loader
              hidden={
                this.props.airports.length > 0 ||
                this.props.theme === Theme.drive ||
                this.props.theme === Theme.multiDrive
              }
            />
            {this.props.children}
          </div>
          <Box fullWidthMobile>
            <Calendar
              actionList
              prices={prices}
              showCheapest={true}
              loading={loading}
              showEasterEgg={[SiteCountry.be, SiteCountry.nl].includes(
                this.props.country,
              )}
              onEasterEggComplete={this.redirectToEntry}
            />
          </Box>
        </Section>
        <FunnelFooter
          nextStepNo={2}
          nextStepLink="flyextras"
          nextStepName={
            <DisplayContent edit={true} contentKey="extras">
              Extras
            </DisplayContent>
          }
          nextStepOnClick={() => {
            addToCart()
            this.setState({ redirect: getNameWithTheme('extras') })
          }}
          nextStepDisabled={nextStepDisabled}
        />
        <GiftcardModal />
        <PriceErrorModal />
      </Page>
    )
  }

  private redirectToEntry = () => {
    this.setState({
      redirect: 'entryPage',
      redirectParams: {
        code: 'nieuwe-bestemmingen',
        month: new Date().getMonth() + 1,
        cheapest: true,
      },
    })
  }
}

export default connect((state: AppState) => ({
  airports: state.funnelOrder.airports,
  country: state.locale.country,
  theme: state.funnelOrder.theme,
  nextStepDisabled: isNaN(state.funnelOrder.total),
}))(Wrapper)
